import { render, staticRenderFns } from "./paso6.vue?vue&type=template&id=5844ebe5&scoped=true&"
import script from "./paso6.vue?vue&type=script&lang=ts&"
export * from "./paso6.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5844ebe5",
  null
  
)

export default component.exports